import { render, staticRenderFns } from "./LargeBold.vue?vue&type=template&id=72906f12&scoped=true"
import script from "./LargeBold.vue?vue&type=script&lang=js"
export * from "./LargeBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72906f12",
  null
  
)

export default component.exports